import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/actionTypes';

class RestartButton extends Component {

    render () {
        return (
            <div className='restartButton'>
                <nav className='nav'>
                    <div
                     onClick={() => this.props.modalOpen()}>
                    <h4>Reiniciar o jogo</h4>
                    </div>
                </nav>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    whatsNext: state.user.whatsNext,
});

const mapDispatchToProps = (dispatch) => ({
    modalOpen: () => dispatch({
        type: ACTIONS.OPEN_PROFILE_MODAL
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(RestartButton);



// WEBPACK FOOTER //
// ./src/views/components/restartButton.js